const state = {
  passoAtual: 1,
  listaUnidades: [],
  listaUsuarios: [],
  listaDocumentos: [],
  unidadeSelecionada: null,
  documentoSelecionado: null,
  numeroDocumento: null
}

export default state
